import { render, staticRenderFns } from "./CompanyInvitePage.vue?vue&type=template&id=734e8ad6&scoped=true"
import script from "./CompanyInvitePage.vue?vue&type=script&lang=js"
export * from "./CompanyInvitePage.vue?vue&type=script&lang=js"
import style0 from "./CompanyInvitePage.vue?vue&type=style&index=0&id=734e8ad6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734e8ad6",
  null
  
)

export default component.exports